export const INC = "INC";
export const USER_ADDED = "USER_ADDED";
export const PLANTS_FETCHED = "PLANTS_FETCHED"